import React, { useState, useEffect } from "react";
import { gql } from '@apollo/client';
import { ApolloClient } from "@apollo/client";
import { InMemoryCache } from "@apollo/client";
import Loading from "../components/layouts/loading";
import './login.scss';
import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import { RestApiUtils } from '../utils/RestApiUtils'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


import { useContext } from 'react';
import AuthContext from '../context/auth-context'

export default function Login() {

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLogged, setIsLogged] = useState(false);
  const [wrongLogin, setWrongLogin] = useState(false);

  useEffect(() => {
    localStorage.removeItem("proxyAuthToken");
    localStorage.removeItem("wpAuthToken");
    localStorage.removeItem("wpAuthRefreshToken");
    localStorage.removeItem("username");
    //console.log("useEffect login...");
  }, []);

  function SignInScreen() {

    //username può essere anche la email
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const form_element = (
      <div className="rounded login-mask">

        <form onSubmit={handleSubmit}>
          <label className="sr-only">Username or Email Address</label>
          <div className="input-group mb-2">
            <div className="input-group-prepend">
              <div className="input-group-text">@</div>
            </div>
            <input id="username"
              name="username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value)
              }}
              type="text" className="form-control" placeholder="Username or Email Address" autoFocus/>
          </div>

          <label style={{ display: "block" }}>Password</label>
          <input id="password"
            name="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
            }}
            type="password" className="form-control" aria-describedby="passwordHelpBlock" />
          <small className="form-text text-muted">
            Your password must be 8-20 characters long, contain letters and numbers, and must not contain spaces, special characters, or emoji.
          </small>
          <br /><br />
          <div style={{ textAlign: "center" }}>
            <button type="submit" className="btn btn-primary">Login</button>
          </div>
        </form>
        {wrongLogin ?
          (<label htmlFor="test" style={{ color: "red" }}>Credenziali errate!</label>) :
          (<label htmlFor="test" style={{ display: "none" }}> </label>)}
      </div>
    );

    async function handleSubmit(e) {
      e.preventDefault();

      const respLogged = await (new RestApiUtils()).loginDJToken({ 'username': username, 'password': password });

      try {

        if (!respLogged) {
          console.log(`Error login: `, respLogged);
          setWrongLogin(true);
          return {
            revalidate: 5,
            notFound: true
          }
        }

        //console.log(`result of POST:`, respLogged);
        if (respLogged.django_token) {
          setIsLogged(true);
          //console.log('token', respLogged.token);
          //console.log('refresh_token', respLogged.refresh_token);
          //console.log('email', respLogged.email);
          //console.log('username', respLogged.name);
          localStorage.setItem("proxyAuthToken", respLogged.django_token)
          localStorage.setItem("wpAuthToken", respLogged.token)
          localStorage.setItem("wpAuthRefreshToken", respLogged.refresh_token)
          localStorage.setItem("username", respLogged.name)
          refreshToken();
          authCtx.refreshIsLogged();
        }
        else {
          console.log(`Error, nessun django token ricevuto!`);
          setWrongLogin(true);
        }

      } catch (e) {
        console.log(e);
        return {
          revalidate: 5,
          notFound: true,
        }
      }
    }

    return (
      <>
        {/* <button type="button" className="btn btn-primary" style={{ width: "8rem", float: "right", marginRight: "12px" }}>
          <Link to="/info">
            <FontAwesomeIcon icon={['fas', 'info']} size={'1x'} color={'white'} />
            <span style={{ margin: "8px", verticalAlign: "center" }}>Info/Guida</span>
          </Link>
        </button> */}
        {form_element}
      </>
    )
  }

  function refreshToken() {
    //console.log('refreshToken...');
    var refreshToken = localStorage.getItem("wpAuthRefreshToken");

    let refreshMutation = gql`mutation MyMutation {
      refreshJwtAuthToken(input: {jwtRefreshToken: "${refreshToken}"}) { authToken }
    }`

    const client = new ApolloClient({
      uri: 'https://admin.startupitalia.eu/index.php?graphql',
      cache: new InMemoryCache(),
    })

    // client.query({query: copied_query, variables: {language: "www", id: 150047}})
    client
      .mutate({ mutation: refreshMutation })
      .then((result) => {
        //console.debug(result);
        //console.log('authToken for refresh', result['data']['refreshJwtAuthToken']['authToken']);

        setIsLogged(true);
        localStorage.setItem("wpAuthToken", result["data"]["refreshJwtAuthToken"]["authToken"]);
        navigate(`/`);
      })
      .catch((err) => {
        console.error(err)
        localStorage.removeItem("proxyAuthToken");
        localStorage.removeItem("wpAuthToken");
        localStorage.removeItem("wpAuthRefreshToken");
        localStorage.removeItem("username");
      })
  }

  return <div style={{ height: "100%", padding: "1rem 0", overflow: "auto" }}>
    {isLogged ? <Loading /> : <SignInScreen />}
  </div>
}
